import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-stories',
  templateUrl: './customer-stories.component.html',
  styleUrls: ['./customer-stories.component.css']
})
export class CustomerStoriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
